import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "watts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.debug || ($props.watt && $props.watt > 0))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "power",
        style: _normalizeStyle($setup.getBackgroundColor())
      }, [
        _createElementVNode("h3", null, _toDisplayString($setup.i18n('POWERSIM_LABEL')), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_1, _toDisplayString($props.watt + ' ' + $setup.i18n('POWERSIM_WATT')), 1 /* TEXT */),
        ($props.debug)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              type: "range",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.simulatedWatt) = $event)),
              min: $setup.MIN_WATT,
              max: $setup.MAX_WATT
            }, null, 512 /* NEED_PATCH */)), [
              [_vModelText, $setup.simulatedWatt]
            ])
          : _createCommentVNode("v-if", true)
      ], 4 /* STYLE */))
    : _createCommentVNode("v-if", true)
}